<template>
    <div>
        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name':'system-content-strings-create'}">Create string</router-link>
            </div>
        </div>

        <content-string-list :items="items" :reload="reload" />
    </div>
</template>
<script>
import contentService from '../../../services/content.service'

import ContentStringList from '../../common/content/string/content-string-list.vue'

export default {
    name: 'system-content-strings',
    components: { ContentStringList },
    data() {
        return {
            items: []
        }
    },
    async created() {
        await this.reload();
    },
    methods: {
        async reload() {
            this.items = await contentService.listStrings(null);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/strings/list.vue